/**
 * STL Color Attribute Images (Asana "STL - Color Attribute Images - dev" 1216438561280997).
 *
 * Option B — exact legacy parity: when a Color variant is selected, swap the PDP hero to that
 * color's image, WITHOUT the color image being a product-media/gallery slide (so it never appears
 * as a thumbnail — matching the old site). The color image lives in the per-variant metafield
 * custom.color_image (url), rendered into #stl-color-images by snippets/stl-color-hero.liquid.
 *
 * Mechanism: an overlay <img> injected over the Splide main carousel (so we don't fight Splide's
 * slide logic). Shown on color-select; hidden when the shopper explores the real gallery
 * (thumbnail / arrow) so the generic photos stay browsable. Inert when the map is absent.
 *
 * Round 4 (Asana 1216635941269933 #3 + #4): preload the color images on first engagement with the
 * picker so the swap is near-instant (no fetch-on-select lag), and gate the reveal on the exact
 * image having loaded + a "latest wins" token so a stale/superseded selection never paints. Also
 * drop the old `change` fallback when the theme publishes variantChange — that fallback read the
 * form's master variant input, which still holds the FIRST variant (amber) during the theme's async
 * section fetch, so it briefly painted amber before the real color. variantChange carries the
 * resolved variant, so it is authoritative here.
 */
(function () {
  'use strict';

  var el = document.getElementById('stl-color-images');
  if (!el) return;
  var map;
  try {
    map = JSON.parse(el.textContent);
  } catch (e) {
    return;
  }
  if (!map || !Object.keys(map).length) return;

  var overlay = null;
  var applyToken = 0; // "latest wins": only the most recent selection is allowed to paint.

  function ensureOverlay() {
    if (overlay && document.body.contains(overlay)) return overlay;
    var main = document.querySelector('.main-carousel');
    if (!main) return null;
    if (getComputedStyle(main).position === 'static') main.style.position = 'relative';
    overlay = main.querySelector('.stl-color-hero-overlay');
    if (!overlay) {
      overlay = document.createElement('img');
      overlay.className = 'stl-color-hero-overlay';
      overlay.setAttribute('alt', '');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('loading', 'eager');
      main.appendChild(overlay);
    }
    return overlay;
  }

  function currentVariantId() {
    var form = document.querySelector(
      'product-info form, product-form form, form[action*="/cart/add"]:not([data-rebuy-id] form)'
    );
    var input = form && form.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  // Warm the browser cache for every color image the moment the shopper engages the picker, so the
  // bytes are already fetched before they click a specific color (kills the select→display lag).
  var preloaded = false;
  function preloadAll() {
    if (preloaded) return;
    preloaded = true;
    Object.keys(map).forEach(function (id) {
      var im = new Image();
      im.decoding = 'async';
      im.src = map[id];
    });
  }

  // Reveal the overlay only once the exact image has loaded, and only if this is still the latest
  // selection (guards against the flash: an early/stale request can never overwrite a newer one).
  function show(url) {
    var ov = ensureOverlay();
    if (!ov) return;
    var token = ++applyToken;
    var pre = new Image();
    var reveal = function () {
      if (token !== applyToken) return; // superseded by a newer selection
      if (ov.getAttribute('src') !== url) ov.src = url;
      ov.classList.add('is-visible');
    };
    pre.onload = reveal;
    pre.onerror = reveal; // fail open — attempt to show even if preflight errors
    pre.src = url;
    if (pre.complete) reveal(); // already cached → paint immediately
  }

  function hide() {
    applyToken++; // cancel any in-flight reveal
    if (overlay) overlay.classList.remove('is-visible');
  }

  function apply(variantId) {
    var url = variantId ? map[variantId] : null;
    if (url) show(url);
    else hide();
  }

  // Do NOT swap the hero on initial load — show the product's generic hero image first, and only
  // reveal a color image once the shopper actively picks a color (round 2, Asana 1216569565481387:
  // "it's not showing the hero image right away... once a customer starts interacting with the
  // colors, then they'll see how it works"). The theme does not publish variantChange on init, and
  // the selection paths below are user-initiated, so the overlay stays hidden until first interaction.

  // Warm the cache on first engagement with the color picker (hover / focus / open / click).
  ['pointerenter', 'focusin', 'click'].forEach(function (evt) {
    document.addEventListener(
      evt,
      function (e) {
        if (
          e.target.closest &&
          e.target.closest(
            'custom-color-dropdown, .product-form__input--color-dropdown, .product-form__input--color'
          )
        ) {
          preloadAll();
        }
      },
      true
    );
  });

  // Primary: the theme's own variant-change pub/sub. It carries the RESOLVED variant, so it never
  // reflects the stale master input the theme is still fetching against.
  var hasPubSub =
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange;

  if (hasPubSub) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var v = event && event.data && event.data.variant;
      apply(v && v.id ? String(v.id) : currentVariantId());
    });
  } else {
    // Fallback ONLY for themes/paths that don't publish variantChange. Read after the theme has had
    // time to resolve the variant (longer than the async section fetch) to avoid a stale read.
    document.addEventListener('change', function (e) {
      if (
        e.target.closest &&
        e.target.closest('variant-selects, variant-radios, .product-form__input, .product-variant-options, product-info')
      ) {
        setTimeout(function () { apply(currentVariantId()); }, 350);
      }
    });
  }

  // When the shopper explores the real gallery (thumbnail or arrow), reveal it by hiding the overlay.
  document.addEventListener('click', function (e) {
    if (
      e.target.closest &&
      e.target.closest('.thumbnail-carousel, .splide__arrow, .thumbnail-list__item, [data-media-id]')
    ) {
      hide();
    }
  }, true);
})();
